import {
  ActualAddress,
  Participants,
  Counterparties,
  Notifiers,
  ServiceOffice,
} from '@ifr/form-questionnaire';
export default [new ActualAddress(), new Participants(), new Counterparties(), new ServiceOffice(), new Notifiers()];
